//This component uses useLocation from react-router-dom to access the products array passed via navigate state (from AuthCallback.tsx). It renders buttons for each active product, redirecting to the corresponding subdomain.
import React from 'react';
import { useLocation } from 'react-router-dom';

const ProductSelector: React.FC = () => {
  const location = useLocation();
  const products: string[] = location.state?.products || [];

  const handleRedirect = (product: string) => {
    const productUrls: { [key: string]: string } = {
      gdpr: 'https://gdpr.compliancehub.com/dashboard',
      landlord: 'https://landlord.compliancehub.com/dashboard',
      foodsafety: 'https://foodsafety.compliancehub.com/dashboard',
    };
    window.location.href = productUrls[product] || '/error';
  };

  return (
    <div>
      <h1>Select a Product</h1>
      <p>You have access to multiple products. Choose one to continue:</p>
      {products.map((product) => (
        <button key={product} onClick={() => handleRedirect(product)}>
          Go to {product.charAt(0).toUpperCase() + product.slice(1)} Dashboard
        </button>
      ))}
    </div>
  );
};

export default ProductSelector;